(() => {
  const formCSS = `
    ._textBody_2aowh_10 > p {
      font-size: 18px;
    }

    ._formDisclaimer_jnbzb_38 > p {
        font-size: 18px;
        line-height: normal;
    }
  `;

  function applyFormStyles(host) {
    const style = document.createElement('style');
    style.textContent = formCSS;
    host.shadowRoot.append(style);
  }

  window.addEventListener(
    'load',
    () => {
      const existingForm = document.querySelector(
        'body > shopify-forms-embed'
      );

      if (existingForm) {
        applyFormStyles(existingForm);
        return;
      }

      const observer = new MutationObserver((records) => {
        for (const record of records) {
          for (const node of record.addedNodes) {
            if (node.nodeName !== 'SHOPIFY-FORMS-EMBED') continue;

            observer.disconnect();
            applyFormStyles(node);
            return;
          }
        }
      });

      observer.observe(document.body, {
        childList: true
      });
    },
    { once: true }
  );
})();